import { render, staticRenderFns } from "./HistorialEmergenciaV2.vue?vue&type=template&id=57391092&scoped=true"
import script from "./HistorialEmergenciaV2.vue?vue&type=script&lang=js"
export * from "./HistorialEmergenciaV2.vue?vue&type=script&lang=js"
import style0 from "./HistorialEmergenciaV2.vue?vue&type=style&index=0&id=57391092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57391092",
  null
  
)

export default component.exports